import { useLanguage } from '../i18n'

const heroProducts = [
  { name: 'NORTE', src: '/assets/brands/norte.webp' },
  { name: 'SUL', src: '/assets/brands/sul.webp' },
  { name: 'LESTE', src: '/assets/brands/leste.webp' },
  { name: 'OESTE', src: '/assets/brands/oeste.webp' },
  { name: 'GeniusLED', src: '/assets/brands/geniusled.webp' },
  { name: 'GeniusLIVE', src: '/assets/brands/geniuslive.webp' },
  { name: 'GeniusLAN', src: '/assets/brands/geniuslan.webp' },
  { name: 'GeniusLINK', src: '/assets/brands/geniuslink.webp' },
]

function ProductJump({ name, src }: { name: string; src: string }) {
  return (
    <a
      href="#produtos"
      className="hero-product-link"
      aria-label={`Ver ${name}`}
      onClick={() => {
        window.dispatchEvent(new CustomEvent('geniuslead:select-product', { detail: name }))
      }}
    >
      <img src={src} alt={name} className="hero-product-logo" />
    </a>
  )
}

export function Hero() {
  const { copy } = useLanguage()

  return (
    <section id="top" className="hero" aria-labelledby="hero-title">
      <img
        className="hero-background"
        src="/assets/hero/hero.webp"
        alt=""
        aria-hidden="true"
      />

      <div className="hero__territories">
        <article className="hero-territory hero-territory--consulting">
          <span className="section-kicker">{copy.hero.consultingKicker}</span>
          <h1 id="hero-title">{copy.hero.consultingTitle.split('\n').map((line, index) => <span key={line}>{index > 0 && <br />}{line}</span>)}</h1>
          <a className="text-link" href="#consultoria">{copy.hero.consultingCta} <span aria-hidden="true">→</span></a>
        </article>

        <article className="hero-territory hero-territory--products">
          <div className="hero-products-panel">
            <div className="hero-products-copy">
              <span className="section-kicker">{copy.hero.productsKicker}</span>
              <h2>
                <span className="hero-title--desktop">{copy.hero.productsTitle}</span>
                <span className="hero-title--mobile">{copy.hero.productsMobileTitle}</span>
              </h2>
            </div>

            <div className="hero-products-stage">
              <div className="hero-products" aria-label="Produtos GeniusLEAD">
                {heroProducts.map((product) => <ProductJump key={product.name} {...product} />)}
              </div>
            </div>

            <p className="hero-products-support">{copy.hero.productsSupport}</p>
            <a className="text-link hero-products-cta" href="#produtos">{copy.hero.productsCta} <span aria-hidden="true">→</span></a>
          </div>
        </article>
      </div>
    </section>
  )
}
